import { useTranslation } from 'react-i18next';

export const useProductionSheetsStrings = () => {
  const { t } = useTranslation();

  return {
    on_production_sheets: t('commodities.onProductionSheet'),
    production_sheets: t('commodities.productionSheet'),
    fresh_check: t('commodities.freshCheck'),
    is_test_market: t('profile.isTestMarket'),
    fresh_check_required: t('commodities.freshCheckRequired'),
    shelf_life_units: t('commodities.shelfLifeUnits'),
    shelf_life: t('commodities.shelfLife'),
    units_of_measure: t('commodities.unitsOfMeasure'),
    units_of_measure_default: t('commodities.unitsOfMeasureDefault'),
    default_units_of_measure: t('commodities.defaultUnitsOfMeasure'),
  };
};
